import React, { useState, useEffect } from "react";
import OnboardingProgressBar from "../OnboardingProgressBar/OnboardingProgressBar";
import "./AccountCreationOnboarding.modules.css";
import FatcaCRSDeclaration from "../FatcaCRSDeclaration/FatcaCRSDeclaration";
import FatcaCRSDeclaration2 from "../FatcaCRSDeclaration/FatcaCRSDeclaration2";
import FatcaCRSDeclaration3 from "../FatcaCRSDeclaration/FatcaCRSDeclaration3";
import FatcaCRSDeclaration4 from "../FatcaCRSDeclaration/FatcaCRSDeclaration4";
import FatcaCRSDeclaration5 from "../FatcaCRSDeclaration/FatcaCRSDeclaration5";
import FatcaCRSDeclaration6 from "../FatcaCRSDeclaration/FatcaCRSDeclaration6";
import FatcaCRSDeclaration7 from "../FatcaCRSDeclaration/FatcaCRSDeclaration7";
import FatcaCRSDeclaration8 from "../FatcaCRSDeclaration/FatcaCRSDeclaration8";
import FatcaCRSDeclaration9 from "../FatcaCRSDeclaration/FatcaCRSDeclaration9";
import RiskProfileDeclaration from "../RiskProfileDeclaration/RiskProfileDeclaration";
import ProductSpecificAgreement from "../ProductSpecificAgreement/ProductSpecificAgreement";
import AcceptPrivacyandCookiePolicy from "../ProductSpecificAgreement/TAndC/AcceptPrivacyandCookiePolicy";
import TAndC from "../ProductSpecificAgreement/TAndC/TAndC";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { Redirect } from "react-router-dom";
import * as AppUrls from "../../../../constants/AppUrls";
import * as Rev from "../ReviewOnboardingSteps/ReviewOnboardingSteps";
import * as Helpers from "../../../../global/Helpers";
import * as utils from "../../../../global/utils";
import * as Constants from "../../../../constants/Constants";
import SessionExpiredPOPup from "../../SessionExpiredPOPup/SessionExpiredPOPup";

const AccountCreationOnboarding = () => {
  //var id = Rev.currentStepCreationAccount.value !== null ? Rev.currentStepCreationAccount.value : 2;

  const { t } = useTranslation();
  const [redirect, setRedirect] = useState(null);
  const [currentStep, setCurrentStep] = useState(2);
  const [IsCallAPI, setIsCallAPI] = useState(false);
  const [count, setCount] = useState(1);
  const [countOFProductSpecificAgreement, setCountOFProductSpecificAgreement] =
    useState(1);
  const totalSteps = 4;
  const totalCount = 9;
  const totalCountOFProductSpecificAgreement = 3;

  useEffect(() => {
    if (Rev.currentStepCreationAccount.value !== null) {
      setCount(1);
      setCountOFProductSpecificAgreement(1);
      setCurrentStep(Rev.currentStepCreationAccount.value);
    }
  }, [Rev.currentStepCreationAccount.value]);

  const handleNextForCallAPISave = () => {
    setIsCallAPI(true);
    // handleNext();
  };
  const handleNext = () => {
    console.log("count", count);
    if (
      currentStep < totalSteps ||
      countOFProductSpecificAgreement < totalCountOFProductSpecificAgreement
    ) {
      if (currentStep == 2) {
        if (count < totalCount) {
          setCount(count + 1);
        } else {
          Rev.currentStepCreationAccount.value = currentStep + 1;
          setCurrentStep(currentStep + 1);
        }
      } else if (currentStep == 4) {
        if (
          countOFProductSpecificAgreement < totalCountOFProductSpecificAgreement
        ) {
          setCount(totalCount);
          setCountOFProductSpecificAgreement(
            countOFProductSpecificAgreement + 1
          );
        } else {
          Rev.currentStepCreationAccount.value = currentStep + 1;
          if (currentStep + 1 > totalSteps) setCurrentStep(totalSteps);
          else setCurrentStep(currentStep + 1);
        }
      } else {
        Rev.currentStepCreationAccount.value = currentStep + 1;
        setCurrentStep(currentStep + 1);
      }
    }
  };

  const handlePrevious = () => {
    ;
    if (currentStep > 1) {
      if (currentStep === 2) {
        if (count > 1) {
          setCount(count - 1);
        } else {
          setCurrentStep(currentStep - 1);
        }
      } else if (currentStep === 3) {
        setCurrentStep(currentStep - 1);
        setCount(9);
      } else if (currentStep === 4) {
        if (countOFProductSpecificAgreement > 1) {
          setCountOFProductSpecificAgreement(
            countOFProductSpecificAgreement - 1
          );
        } else {
          setCurrentStep(currentStep - 1);
        }
      } else {
        setCurrentStep(currentStep - 1);
      }
      setIsCallAPI(false);
    }
  };

  const handleNextsetCount = () => {
    if (count < totalCount) {
      setCount(count + 1);
    }
  };

  const handleCountPrevious = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };
  const handleNextsetCountOFProductSpecificAgreement = () => {
    if (
      countOFProductSpecificAgreement < totalCountOFProductSpecificAgreement
    ) {
      setCountOFProductSpecificAgreement(countOFProductSpecificAgreement + 1);
    }
  };

  const handleCountOFProductSpecificAgreementPrevious = () => {
    if (countOFProductSpecificAgreement > 1) {
      setCountOFProductSpecificAgreement(countOFProductSpecificAgreement - 1);
    }
  };

  const SubmitPopUP = async () => {
    // e.preventDefault();
    var Items = [{ ID: "258", Value: "2" }];
    var Items = [{ ID: "312", Value: "Y" }];
    try {
      const body = {
        RequestItems: Items,
        reqID: localStorage.getItem("RID"),
      };
      SubmitPopUPconfirm();

      var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            setIsCallAPI(false);
            // SubmitPopUPconfirm();
          } else if (response.data.Error_code === "-1") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.Error_Msg, i18next.language);
            setIsCallAPI(false);
          }
        })
        .catch((error) => {
          console.log("saveKycData", error);
          setIsCallAPI(false);
        });
    } catch (error) {
      setIsCallAPI(false);
      console.error("Error posting data saveKycData:", error);
    }
  };

  const SubmitPopUPconfirm = () => {
    var dir = "ltr";
    if (i18next.language == "ar") {
      dir = "rtl";
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className={
              "custom-popup custom-scrollable Onboarding-SubmitPopup " +
              localStorage.getItem(
                Constants.localStorageConstants.company_name
              ) +
              "-CSS"
            }
            style={{ direction: dir }}
          >
            {/* <div className='custom-popup-header pt-2'>
                            <div style={{ fontSize: "14px" }}>
                                <strong className="lableCustomizedTransfers">
                          
                                </strong>
                            </div>
                            <div>
                                <span
                                    className="my-panel-extra-btn"
                                    style={{
                                        marginLeft: "auto",
                                        float: "right",
                                        transition: "none",
                                        color: "white",
                                        opacity: "1",
                                        contain: "content",
                                        width: "unset",
                                        marginRight: "unset"
                                    }}
                                    onClick={onClose}>X
                                    </span>
                            </div>
                        </div> */}

            <div className="custom-popup-body pt-2 pb-2">
              {<label>{t("Onboarding-SubmitPopupMSG")}</label>}

              <div className="mt-3 mb-2" style={{ textAlign: "center" }}>
                <button
                  className={"btn custom-btn-cancel SubmitPopupMSG"}
                  style={{
                    background:
                      localStorage.getItem(
                        Constants.localStorageConstants.company_name
                      ) === "ADCB"
                        ? "linear-gradient(to right, #dc2623, #ec0100)"
                        : "  background: linear-gradient(to right, #FAA634, #E37D00)",
                  }}
                  onClick={(e) => {
                    setRedirect(AppUrls.login);
                    onClose();
                  }}
                >
                  {t("ok")}
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };
  const DoItLaterPopUP = () => {
    // e.preventDefault();
    var dir = "ltr";
    if (i18next.language == "ar") {
      dir = "rtl";
    }
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className={
              "custom-popup custom-scrollable Onboarding-SubmitPopup " +
              localStorage.getItem(
                Constants.localStorageConstants.company_name
              ) +
              "-CSS"
            }
            style={{ direction: dir, height: "145px", width: "280px" }}
          >
            <div className="custom-popup-body pt-2 pb-2">
              {<label>{t("DoItLaterMsg")}</label>}
              <div className="mt-3 mb-2" style={{ textAlign: "center" }}>
                <button
                  className={"btn custom-btn-cancel "}
                  style={{
                    background:
                      localStorage.getItem(
                        Constants.localStorageConstants.company_name
                      ) === "ADCB"
                        ? "linear-gradient(to right, #dc2623, #ec0100)"
                        : "  background: linear-gradient(to right, #FAA634, #E37D00)",
                  }}
                  onClick={(e) => {
                    setRedirect(AppUrls.login);
                    onClose();
                  }}
                >
                  {t("ok")}
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };

  const saveKycData = async (Items) => {
    try {
      // const data1 = {
      //     RequestItems: [
      //         {
      //             ID: "String content",
      //             Value: "String content"
      //         }
      //     ],
      //     reqID: "String content"
      // }
      const body = {
        RequestItems: Items,
        reqID: localStorage.getItem("RID"),
      };

      var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            setIsCallAPI(false);
            handleNext();
          } else if (response.data.Error_code === "-1") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.Error_Msg, i18next.language);
            setIsCallAPI(false);
          }
        })
        .catch((error) => {
          console.log("saveKycData", error);
          setIsCallAPI(false);
        });
    } catch (error) {
      setIsCallAPI(false);
      console.error("Error posting data saveKycData:", error);
    }
  };

  if (redirect !== null) {
    return <Redirect to={redirect} />;
  }
  return (
    <>
      <div className="account-creation">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            className=""
            style={{ textAlign: "start", marginBottom: "1rem" }}
          >
            {currentStep === 1 && <div>{t("profile")}</div>}
            {currentStep === 2 && <div>{t("FatcaCRSDeclaration")}</div>}
            {currentStep === 3 && <div>{t("RiskProfile")}</div>}
            {currentStep === 4 && <div>{t("BankDetails")} </div>}
            {/* {currentStep === 5 && <div>Step 3: Review</div>} */}
            {/* <div className="form-buttons">
                    {currentStep > 1 && <button onClick={handlePrevious}>Previous</button>}
                    {currentStep < totalSteps && <button onClick={handleNext}>Next</button>}
                    {currentStep === totalSteps && <button>Submit</button>}
                </div> */}
          </div>
          <button className="DoItLaterBtn" onClick={DoItLaterPopUP}>
            {t("DoItLater")}
          </button>
        </div>

        <OnboardingProgressBar
          currentStep={currentStep}
          totalSteps={totalSteps}
        />

        {/* <div className="form-content stepColor">
          {
            <div className="progress-step-Text1" style={{ color: `${currentStep === 1 ? "#E37D00" : `${currentStep > 1 ? "#0b1d81" : "gray"}`}` }}>
              {t("profile")}
            </div>
          }
          {
            <div className="progress-step-Text2" style={{ color: `${currentStep === 2 ? "#E37D00" : `${currentStep > 2 ? "#0b1d81" : "gray"}`}` }}>
              {t("FatcaCRSDeclaration")}
            </div>
          }
          {
            <div className="progress-step-Text3" style={{ color: `${currentStep === 3 ? "#E37D00" : `${currentStep > 3 ? "#0b1d81" : "gray"}`}` }}>
              {t("RiskProfile")}
            </div>
          }
          {
            <div className="progress-step-Text4" style={{ color: `${currentStep === 4 ? "#E37D00" : `${currentStep > 4 ? "#0b1d81" : "gray"}`}` }}>
              {t("BankDetails")}
            </div>
          }
        </div> */}

        <div className="form-content stepColor">
          {(() => {
            const companyName = localStorage
              .getItem(Constants.localStorageConstants.company_name)
              ?.toUpperCase();

            const isNotSIFS = companyName !== "SIFS";

            const activeColor = isNotSIFS ? "#BA1B19" : "#E37D00";
            const doneColor = isNotSIFS ? "black" : "#0b1d81";
            const defaultColor = "gray";

            return (
              <>
                <div
                  className="progress-step-Text1"
                  style={{
                    color:
                      currentStep === 1
                        ? activeColor
                        : currentStep > 1
                        ? doneColor
                        : defaultColor,
                  }}
                >
                  {t("profile")}
                </div>
                <div
                  className="progress-step-Text2"
                  style={{
                    color:
                      currentStep === 2
                        ? activeColor
                        : currentStep > 2
                        ? doneColor
                        : defaultColor,
                  }}
                >
                  {t("FatcaCRSDeclaration")}
                </div>
                <div
                  className="progress-step-Text3"
                  style={{
                    color:
                      currentStep === 3
                        ? activeColor
                        : currentStep > 3
                        ? doneColor
                        : defaultColor,
                  }}
                >
                  {t("RiskProfile")}
                </div>
                <div
                  className="progress-step-Text4"
                  style={{
                    color:
                      currentStep === 4
                        ? activeColor
                        : currentStep > 4
                        ? doneColor
                        : defaultColor,
                  }}
                >
                  {t("BankDetails")}
                </div>
              </>
            );
          })()}
        </div>
      </div>

      {currentStep === 2 ? (
        count === 1 ? (
          <FatcaCRSDeclaration
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : count === 2 ? (
          <FatcaCRSDeclaration2
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : count === 3 ? (
          <FatcaCRSDeclaration3
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : count === 4 ? (
          <FatcaCRSDeclaration4
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : count === 5 ? (
          <FatcaCRSDeclaration5
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : count === 6 ? (
          <FatcaCRSDeclaration6
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
            handleNext={handleNext}
          />
        ) : count === 7 ? (
          <FatcaCRSDeclaration7
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : count === 8 ? (
          <FatcaCRSDeclaration8
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
            handleNext={handleNext}
          />
        ) : count === 9 ? (
          <FatcaCRSDeclaration9
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : null
      ) : currentStep === 3 ? (
        <RiskProfileDeclaration
          saveKycDataAPI={saveKycData}
          setIsCallAPI={setIsCallAPI}
          IsCallAPI={IsCallAPI}
          handleNext={handleNext}
        />
      ) : currentStep === 4 ? (
        countOFProductSpecificAgreement === 1 ? (
          <ProductSpecificAgreement
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
            handleNext={handleNext}
            saveKycDataAPI={saveKycData}
          />
        ) : countOFProductSpecificAgreement === 2 ? (
          <TAndC
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
            handleNext={handleNext}
            saveKycDataAPI={saveKycData}
          />
        ) : countOFProductSpecificAgreement === 3 ? (
          <AcceptPrivacyandCookiePolicy
            saveKycDataAPI={saveKycData}
            setIsCallAPI={setIsCallAPI}
            IsCallAPI={IsCallAPI}
          />
        ) : null
      ) : null}

      {/* {currentStep === 2 ?
                <div className="form-buttons-sub-steps">
                    {count > 1 && <button onClick={handleCountPrevious}>Previous</button>}
                    {count < totalCount && <button onClick={handleNextsetCount}>Proceed</button>}

                </div>
                : null}

            {currentStep === 4 ?
                <div className="form-buttons-sub-steps">
                    {countOFProductSpecificAgreement > 1 && <button onClick={handleCountOFProductSpecificAgreementPrevious}>Previous</button>}
                    {countOFProductSpecificAgreement < totalCountOFProductSpecificAgreement && <button onClick={handleNextsetCountOFProductSpecificAgreement}>Proceed</button>}

                </div>
                
                : null} */}

      <div className="form-buttons-sub-steps">
        {currentStep > 2 || count > 1 ? // </button> //   {t("Previous")} // <button className="PreviousBTN" onClick={handlePrevious}>
        null : (
          <button style={{ background: "transparent" }}></button>
        )}
        {(currentStep < totalSteps ||
          count < totalCount ||
          countOFProductSpecificAgreement <
            totalCountOFProductSpecificAgreement) && (
          <button onClick={handleNextForCallAPISave}>{t("Next")}</button>
        )}
        {currentStep === totalSteps &&
          countOFProductSpecificAgreement ===
            totalCountOFProductSpecificAgreement && (
            <button onClick={SubmitPopUP}>{t("submit")}</button>
          )}
      </div>
    </>
  );
};

export default AccountCreationOnboarding;
